import './ContactForm.scss'
import { FaAddressCard, FaEnvelope, FaPen, FaPhone } from "react-icons/fa";
import { useEffect } from "react";
import video1 from '../../Assets/videos/compressed/Dji_social.mp4';
import { motion } from "framer-motion";
import "../../i18n";
import { useTranslation } from "react-i18next";
import React from 'react';
import LoadingButton from '../../Components/Buttons/LoadingButton/LoadingButton';
import MovingDotsBackground from '../../Components/Background/AnimatedDotBackground';
import useDetectView from '../../Components/Hook/useDetectView';
import { View } from '../../Data/Constants';

export const ContactForm = () => {
    const { t } = useTranslation();
    const fnameRef = React.useRef<HTMLInputElement>(null);
    const lnameRef = React.useRef<HTMLInputElement>(null);
    const emailRef = React.useRef<HTMLInputElement>(null);
    const messageRef = React.useRef<HTMLTextAreaElement>(null);
    const currentView = useDetectView();

    const handleButtonClick = () => {
        return;
    };

    useEffect(() => {
        const inputs = document.querySelectorAll<HTMLInputElement>(".contact-input")

        inputs.forEach(ipt => {
            if (ipt) {
                ipt.addEventListener("focus", () => {
                    const parent = ipt.parentNode as HTMLElement;
                    parent.classList.add("focus");
                    parent.classList.add("not-empty");
                })
                ipt.addEventListener("blur", () => {
                    const parent = ipt.parentNode as HTMLElement;
                    if (ipt.value === "") {
                        parent.classList.remove("not-empty");
                    }
                    parent.classList.remove("focus");
                })
            }
        })
    }, []);

    return (
        <section className="contact">
            {
                currentView !== View.Desktop ? <MovingDotsBackground /> : <></>
            }
            <div className="contact-container">
                <motion.div className="contact-column-left" initial={{ opacity: 0, x: '-100vw' }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }}>
                    <div className="form-wrapper">
                        <div className="contact-heading">
                            <h1>{t("contact.title.title")}<span>.</span></h1>
                            <div className="text"><span><FaEnvelope /> </span><a style={{ marginRight: "45px" }} href="mailto:info@simdev.ca">info@simdev.ca</a><span><FaPhone /> </span>(514) 316-8685</div>
                        </div>
                        {/*<form onSubmit={handleSubmit} method="post" className="contact-form">*/}
                        <form action="https://api.web3forms.com/submit" method="POST" className="contact-form">
                            <input type="hidden" name="access_key" value="bdf8ae60-c856-4c63-aefa-bd7d67f52f2a"></input>
                            <div className="input-wrap">
                                <input ref={fnameRef} className="contact-input" type="text" autoComplete="off" id="fname" name="fname" required />
                                <label>{t("contact.form.fields.first-name")}</label>
                                <i className="icon"><FaAddressCard /></i>
                            </div>

                            <div className="input-wrap">
                                <input ref={lnameRef} className="contact-input" type="text" autoComplete="off" id="lname" name="lname" required />
                                <label>{t("contact.form.fields.last-name")}</label>
                                <i className="icon"><FaAddressCard /></i>
                            </div>

                            <div className="input-wrap w-100">
                                <input ref={emailRef} className="contact-input" type="email" autoComplete="off" id="email" name="email" required />
                                <label>{t("contact.form.fields.email")}</label>
                                <i className="icon"><FaEnvelope /></i>
                            </div>

                            <div className="input-wrap textarea w-100">
                                <textarea ref={messageRef} className="contact-input" autoComplete="off" id="message" name="message" required />
                                <label>{t("contact.form.fields.message")}</label>
                                <i className="icon"><FaPen /></i>
                            </div>

                            {/*BOT DETECTION*/}
                            <div>
                                <input type="text" name="botcheck" style={{ display: "none" }} />
                            </div>

                            {/*DEVELOPMENT ENVIRONNEMENT*/}
                            <input type="hidden" name="redirect" value="https://simdev.ca/nousrejoindre/merci" />

                            {/* PROD ENVIRONNEMENT */}
                            {/*<input type="hidden" name="redirect" value="https://yourwebsite.com/nousrejoindre/merci"/>*/}

                            <div className='text-warp w-100'>
                                <div>{t("contact.form.warning.partOne")}<a href="/avis-legal"> {t("contact.form.warning.partTwo")}</a> {t("contact.form.warning.partThree")}<a href="/politique-confidentialite"> {t("contact.form.warning.partFour")}</a> {t("contact.form.warning.partFive")}</div>
                            </div>
                            <div className='button-wrap w-100'>
                            <LoadingButton onClick={handleButtonClick} isSubmitting={false} text={t("contact.form.button")} error={false} />
                            </div>
                        </form>
                    </div>
                </motion.div>
                <motion.div className="contact-column-right" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5, duration: 1.5 }}>
                    <div className="image-wrapper">
                        <video src={video1} className='vid' disablePictureInPicture={true} autoPlay={true} muted loop playsInline={true} />
                        <div className="video-overlay"></div>
                    </div>
                </motion.div>
            </div>
            <script src="https://web3forms.com/client/script.js" async defer></script>
        </section>
    );
};

export default ContactForm;
